import { ArrowBackButtonIcon } from "assets/images";

const ArrowBackWardButtonIcon = () => {
  return <img src={ArrowBackButtonIcon} alt="arrow-backward" />;
};

export default ArrowBackWardButtonIcon;
